import React,{useState, useEffect} from 'react';
import {GetAllPostTemplates} from '../../services/servicesGetAllPostTemplates';
import {URLIMG} from '../../helpers/constantes';
import {Link, useLocation,useHistory} from 'react-router-dom';
import {DivImage,Image} from '../busca/styleBusca';
import {InputBusca} from './styledUnblockedPosts';
import Toastify from '../../components/Toastify';
export default function UnblockedPosts(){

    const[dados, setDados] = useState([]);
    const[busca, setBusca] = useState('');
    const location = useLocation();
    const history = useHistory();
    function RealizaBusca(string) {
       setBusca(string);
       if(string.length > 3)
        LoadAllPosts(string);
        else if (string ===''){
            LoadAllPosts('')
        }
    }
    function redirectURL({pathname, state}){
        history.push(pathname)
        location.pathname = pathname
    }
    async function LoadAllPosts(string){
        try{
            const data = await GetAllPostTemplates(string);
            setDados(data);
        }catch(error){
            Toastify.error('deu ruim')
        }


    }

    const EscreveBusaca = (string) =>{
        setBusca(string);
    }

    function ArrumaData(date){
        let data = date.split('T');
        return data[0];
    }

    useEffect(()=>{
        LoadAllPosts('vida')
    },[])

    return(<div style={{height:'calc(100% - 60px)',width:'100%', overflow:'hidden auto'}}>
    <InputBusca type='text' placeholder='Insira o nome do post desejado'
        value={busca}
        onChange={(event)=>{RealizaBusca(event.target.value)}}
         />
    <div style={{display:'flex', flexDirection:'column',width:'100vw',flexWrap:'wrap',}}>
        {dados.length>0? dados.map((item,index)=>{
        return(<div key={index} style={{display:'flex',justifyAlign:'center'}}>

        <div style={{margin:'20px',cursor:'pointer'}} onClick={()=> redirectURL({pathname:`/app/templateedit/${item.Id}`})}>
            <h1>{item.PostTitle}</h1>
            <p>{ArrumaData(item.Date).split('-')[2] }/{ArrumaData(item.Date).split('-')[1] }/{ArrumaData(item.Date).split('-')[0] }</p>
        </div>

        </div>
        )
    })
    :<div><h1>Vazio</h1> </div>
    }
    </div>
    </div>)
}
